/* uncomment for custom sort dropdown (must also uncomment styling in `serp.css`) */
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "./../config"

export default function SortBy() {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const [ focusIndex, setFocusIndex ] = useState(sortOptions.findIndex(opt => opt.id === activeSort) ?? 0);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);

    useEffect(() => {
        if (sortOpen && dropdownRef.current && dropdownRef.current.children.length) {
            const selectedElement = dropdownRef.current.children[focusIndex];
            if (selectedElement) {
                setTimeout(() => {
                    selectedElement.focus();
                }, 50)
            }
        }
    }, [ sortOpen, focusIndex ]);

    useEffect(() => { // keyboard controls
        const handleKeydown = (event) => {
            switch(event.key) {
                case "Escape":
                case "Tab" :
                    setSortOpen(false);
                    toggleRef?.current?.focus();
                    break;
                case "ArrowUp":
                    event.preventDefault();
                    setFocusIndex(prevFocusIndex => (prevFocusIndex > 0) ? prevFocusIndex - 1 : sortOptions.length - 1)
                    break;
                case "ArrowDown":
                    event.preventDefault();
                    setFocusIndex(prevFocusIndex => (prevFocusIndex < (sortOptions.length - 1)) ? prevFocusIndex + 1 : 0)
                    break;
                case "Enter":
                    event.preventDefault();
                    const optionId = dropdownRef.current.children[focusIndex].getAttribute('data-id');
                    setSort(optionId);
                    setSortOpen(false);
                    toggleRef?.current?.focus();
                    break;
                default:
                    break;
            }
        }
        if(sortOpen && dropdownRef.current) {
            window.document.addEventListener('keydown', handleKeydown)
            return () => window.document.removeEventListener('keydown', handleKeydown)
        }
    }, [ sortOpen, focusIndex ])
    
    useEffect(() => { // close dropdown on outside clicks
        const handleClick = (event) => {
            if(
                !dropdownRef.current.contains(event.target) && 
                !toggleRef.current.contains(event.target)
            ) {
                setSortOpen(false);
                toggleRef?.current?.focus();
            };
        };

        if(sortOpen && dropdownRef?.current && toggleRef?.current) {
            window.document.addEventListener('click', handleClick);
            return () => window.document.removeEventListener('click', handleClick);
        };
    }, [ sortOpen ]);

    const handleOptionClick = (event) => {
        const optionId = event.target.getAttribute('data-id');
        setSort(optionId);
        setFocusIndex(sortOptions.findIndex(opt => opt.id === optionId));
        setSortOpen(false);
        toggleRef?.current?.focus();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
        setFocusIndex(0);
    };

    return (
        <div class="ns-sort-wrap">
            <div class="ns-sort-toggle-wrap">
                <button 
                    type="button"
                    class="ns-sort-toggle ns-flex ns-flex-nowrap"
                    aria-haspopup="listbox"
                    aria-controls="ns-sort-dropdown"
                    aria-labelledby="ns-sort-header"
                    aria-expanded={sortOpen}
                    tabIndex="0"
                    onClick={toggleSort}
                    ref={toggleRef}
                >
                    <h4 id="ns-sort-header" class="ns-sort-header ns-flex ns-flex-col ns-items-end">
                        <span class="ns-folio-reg">Sort by</span>
                    </h4>
                    <span class="ns-toggle-icon ns-relative" role="presentation" aria-hidden="true" />
                </button>
            </div>
            <div>
                <ul
                    class="ns-list-unstyled ns-absolute ns-flex ns-flex-col"
                    id="ns-sort-dropdown"
                    aria-labelledby="ns-sort-header"
                    aria-hidden={!sortOpen}
                    ref={dropdownRef}
                    role="listbox"
                    tabIndex="-1"
                >
                    {sortOptions.map((option, i) => (
                        <li
                            class="ns-sort-list-option ns-folio-reg ns-flex ns-flex-nowrap ns-items-center"
                            role="option"
                            data-id={option.id}
                            onClick={handleOptionClick}
                            aria-selected={(activeSort === option.id)}
                            tabIndex={i === focusIndex ? "0" : "-1"}
                            key={option.id}
                        >
                            {option.value.name}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}


/* sort with <select> */
/*
import { useSort } from "@nosto/preact"
import { sortOptions } from "./../config"

export default function SortBy() {
    const { setSort } = useSort(sortOptions)
    const options = sortOptions.map(o => ({ value: o.id, name: o.value.name }))

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    return (
        <div class="ns-sort-wrap ns-relative">
            <select
                class="ns-folio-reg"
                id="ns-sort"
                // value={activeSort}
                onChange={(e) => handleSortChange(e)}
                aria-label="Sort by"
            >
                <option disabled selected>Sort By</option>
                {options.map(option => (
                    <option 
                        key={option.value} 
                        value={option.value}
                    >
                        {option.name}
                    </option>
                ))}
            </select>
            <span class="ns-toggle-icon ns-absolute" role="presentation" aria-hidden="true" />
        </div>
    )
}
*/